import { useMemo } from 'react';

const NEW_BADGE_DURATION_DAYS = 60;

/**
 * Hook that determines whether a "NEW" badge should be displayed.
 * The badge is shown from `badgeStartDate` (UTC) until 60 days after (inclusive).
 * On day 61 (UTC), the badge is no longer rendered.
 *
 * @param badgeStartDate - UTC date string (ISO 8601) when the badge starts showing.
 * @returns `true` if the badge should be displayed, `false` otherwise.
 */
const useNewBadge = (badgeStartDate: string): boolean => {
  return useMemo(() => {
    const startDate = new Date(badgeStartDate);
    if (isNaN(startDate.getTime())) {
      return false;
    }

    const now = new Date();
    const expirationDate = new Date(startDate);
    expirationDate.setUTCDate(expirationDate.getUTCDate() + NEW_BADGE_DURATION_DAYS);
    // Badge is active from startDate until end of day 60 (inclusive)
    return now >= startDate && now <= expirationDate;
  }, [badgeStartDate]);
};

export default useNewBadge;
